import type { Plan } from '@otter-ai/recall-client';
import type { useTranslations } from 'next-intl';

const PLAN_TYPE_TO_I18N_KEY: Record<string, string> = {
  premium: 'pro',
  team: 'business',
  enterprise: 'enterprise',
  free: 'basic',
  reward: 'proLite',
  team_free_pro: 'teamFreePro',
  team_free: 'teamFree',
} as const;

export function getPlanTitleFromPlan(
  plan: Plan,
  t: ReturnType<typeof useTranslations>,
) {
  const planType = plan.type;
  const translationKey = PLAN_TYPE_TO_I18N_KEY[planType];
  return t(translationKey);
}
